export const fetchCustomTags = async (locale: string, signal?: AbortSignal) => {
  try {
    const res = await fetch(`/api/injection-script?locale=${locale}`, {
      signal,
    });

    if (!res.ok) throw new Error('Failed to fetch');

    const data = await res.json();

    return data;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw error;
    }
    console.error('Error fetching data:', error);
  }
};
